import { createSlice } from "@reduxjs/toolkit";
import { fetchFixedAssetBalance } from "./fixedAssetBalanceThunk";

const initialState = {
  list: [],
  total_balance: 0,
  filters: {
    type: "All Fixed Asset Account",
    accId: null,
    fromDate: null,
    toDate: null,
  },
  loading: false,
};

const fixedAssetBalanceSlice = createSlice({
  name: "fixedAssetBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFixedAssetBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFixedAssetBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list;
        state.total_balance = action.payload.total_balance;
      })
      .addCase(fetchFixedAssetBalance.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = fixedAssetBalanceSlice.actions;
export default fixedAssetBalanceSlice.reducer;
